<nb-layout>
    <nb-sidebar class="menu-sidebar" tag="menu-sidebar" #sb>
        <div class="logo-wrapper d-flex align-items-center">
            <img class="main-logo" ngSrc="/assets/images/BIA Systems v1.svg" alt="BIA" height="20" width="93" />
            <button
                class="tw:ml-auto tw:p-1 tw:text-muted-foreground tw:hover:bg-accent tw:lg:block"
                (click)="sb.compacted ? sb.expand() : sb.compact()"
            >
                <svg lucideMenu size="16"></svg>
            </button>
        </div>
        <div class="menu-container no-scroll tw:px-1 tw:py-2">
            <div class="main-menu-content">
                <ng-content select="[tag='mainMenu']"></ng-content>
            </div>
            <ng-content select=".bottom-menu"></ng-content>
        </div>
    </nb-sidebar>
    <nb-layout-column>
        <div class="content-wrapper">
            <router-outlet class="tab-content"></router-outlet>
        </div>
    </nb-layout-column>
</nb-layout>
